// import React, { useCallback, useEffect, useState } from "react";
// import { Box, Typography, CircularProgress } from "@mui/material"; // Added CircularProgress
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { RxCross2 } from "react-icons/rx";
// import { customTextColor } from "../../utils/const";
// import { getAllCandidate } from "../../redux/candidate/candidateSlice";
// import CreateHotListDraw from "./CreateHotListDraw";
// import { useDispatch, useSelector } from "react-redux";
// import { allLocation } from "../../redux/common/locationSlice";

// const CandidateListDrawer = ({ show, handleClose, hotListName }) => {
//   const dispatch = useDispatch();
//   const [showHotListDrawer, setShowHotListDrawer] = useState(false);
//   const locations = useSelector((state) => state.location) || [];
//   const candidateData = useSelector((store) => store?.candidate?.data || {});
//   const {
//     profiles = [],
//     next_page = null,
//     total_resume_profiles = 0,
//     total_pages = 0,
//     current_page = 1,
//     success = false,
//   } = candidateData;

//   console.log(profiles, "profiles", success, locations);

//   const queryParams = {};

//   useEffect(() => {
//     dispatch(getAllCandidate(queryParams));
//     dispatch(allLocation());
//   }, [dispatch]);

//   const getLocationById = (id) => {
//     let locationResult = locations?.data?.locations?.find(
//       (res) => res.id === id
//     );
//     return locationResult?.name;
//   };

//   const handleCloseHotListDrawer = useCallback(() => {
//     setShowHotListDrawer(false);
//   }, []);

//   return (
//     <Offcanvas
//       show={show}
//       onHide={handleClose}
//       placement="end"
//       scroll={true}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "50%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <Box sx={{ padding: "10px 10px" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "0px 10px",
//             }}
//           >
//             <Typography>Candidate Listing | {hotListName}</Typography>
//             <RxCross2
//               style={{
//                 fontSize: "15px",
//                 cursor: "pointer",
//                 color: customTextColor,
//               }}
//               onClick={handleClose}
//             />
//           </Box>

//           {/* Candidate List or Circular Progress */}
//           <Box sx={{ marginTop: "10px", padding: "0px 10px" }}>
//             {!success ? (
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   padding: "20px",
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             ) : profiles.length === 0 ? (
//               <Typography sx={{ textAlign: "center", padding: "20px" }}>
//                 No candidates found.
//               </Typography>
//             ) : (
//               <>
//                 {profiles?.map((candidate, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       padding: "10px",
//                       border: "1px solid #e0e0e0",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-end",
//                       borderRadius: "3px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     <Box>
//                       <Typography>{candidate.full_name}</Typography>
//                       <Typography style={{ margin: "5px 0" }}>
//                         {candidate.current_job_title},{" "}
//                         {candidate.total_experience} Years
//                       </Typography>
//                       <Typography>
//                         {getLocationById(candidate?.current_location)}
//                       </Typography>
//                       <Typography>${candidate.rate} Hourly</Typography>
//                     </Box>
//                     <button
//                       style={{
//                         padding: "5px 10px",
//                         backgroundColor: "#f0f0f0",
//                         border: "none",
//                         borderRadius: "2px",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Add to Hotlist
//                     </button>
//                   </Box>
//                 ))}
//                 <Box sx={{ textAlign: "right", padding: "10px" }}>
//                   <Typography
//                     style={{
//                       padding: "5px 10px",
//                       border: "none",
//                       borderRadius: "5px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Load More
//                   </Typography>
//                 </Box>
//               </>
//             )}
//           </Box>
//         </Box>
//         {showHotListDrawer && (
//           <CreateHotListDraw
//             show={showHotListDrawer}
//             handleClose={handleCloseHotListDrawer}
//             hotListName={hotListName}
//           />
//         )}
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default CandidateListDrawer;

// import React, { useCallback, useEffect, useState } from "react";
// import { Box, Typography, CircularProgress } from "@mui/material";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { RxCross2 } from "react-icons/rx";
// import { customTextColor } from "../../utils/const";
// import { getAllCandidate } from "../../redux/candidate/candidateSlice";
// import CreateHotListDraw from "./CreateHotListDraw";
// import { useDispatch, useSelector } from "react-redux";
// import { allLocation } from "../../redux/common/locationSlice";

// const CandidateListDrawer = ({
//   show,
//   handleClose,
//   hotListName,
//   hotListId,
//   candidateList,
// }) => {
//   const dispatch = useDispatch();
//   const [showHotListDrawer, setShowHotListDrawer] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null); // Local state for selected candidate
//   console.log("candidateList", candidateList);

//   const locations = useSelector((state) => state.location) || [];
//   const candidateData = useSelector((store) => store?.candidate?.data || {});
//   const {
//     profiles = [],
//     next_page = null,
//     total_resume_profiles = 0,
//     total_pages = 0,
//     current_page = 1,
//     success = false,
//   } = candidateData;

//   console.log(
//     profiles,
//     "profiles",
//     success,
//     locations,
//     selectedCandidate,
//     selectedCandidate
//   );

//   const queryParams = {};

//   useEffect(() => {
//     dispatch(getAllCandidate(queryParams));
//     dispatch(allLocation());
//   }, [dispatch]);

//   const getLocationById = (id) => {
//     let locationResult = locations?.data?.locations?.find(
//       (res) => res.id === id
//     );
//     return locationResult?.name || "Unknown Location";
//   };

//   const handleCloseHotListDrawer = useCallback(() => {
//     setShowHotListDrawer(false);
//     setSelectedCandidate(null); // Clear the selected candidate when closing the drawer
//   }, []);

//   const handleAddToHotlist = (candidate) => {
//     // Store the selected candidate in local state
//     setSelectedCandidate(candidate);
//     // Open the hotlist drawer
//     setShowHotListDrawer(true);
//   };

//   return (
//     <Offcanvas
//       show={show}
//       onHide={handleClose}
//       placement="end"
//       scroll={true}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "50%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <Box sx={{ padding: "10px 10px" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "0px 10px",
//             }}
//           >
//             <Typography>Candidate Listing | {hotListName}</Typography>
//             <RxCross2
//               style={{
//                 fontSize: "15px",
//                 cursor: "pointer",
//                 color: customTextColor,
//               }}
//               onClick={handleClose}
//             />
//           </Box>

//           {/* Candidate List or Circular Progress */}
//           <Box sx={{ marginTop: "10px", padding: "0px 10px" }}>
//             {!success ? (
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   padding: "20px",
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             ) : profiles.length === 0 ? (
//               <Typography sx={{ textAlign: "center", padding: "20px" }}>
//                 No candidates found.
//               </Typography>
//             ) : (
//               <>
//                 {profiles?.map((candidate, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       padding: "10px",
//                       border: "1px solid #e0e0e0",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-end",
//                       borderRadius: "3px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     <Box>
//                       <Typography>{candidate.full_name}</Typography>
//                       <Typography style={{ margin: "5px 0" }}>
//                         {candidate.current_job_title},{" "}
//                         {candidate.total_experience} Years
//                       </Typography>
//                       <Typography>
//                         {getLocationById(candidate?.current_location)}
//                       </Typography>
//                       <Typography>${candidate.rate} Hourly</Typography>
//                     </Box>
//                     <button
//                       style={{
//                         padding: "5px 10px",
//                         backgroundColor: "#f0f0f0",
//                         border: "none",
//                         borderRadius: "2px",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => handleAddToHotlist(candidate)}
//                     >
//                       Add to Hotlist
//                     </button>
//                   </Box>
//                 ))}
//                 <Box sx={{ textAlign: "right", padding: "10px" }}>
//                   <Typography
//                     style={{
//                       padding: "5px 10px",
//                       border: "none",
//                       borderRadius: "5px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Load More
//                   </Typography>
//                 </Box>
//               </>
//             )}
//           </Box>
//         </Box>
//         {showHotListDrawer && (
//           <CreateHotListDraw
//             show={showHotListDrawer}
//             handleClose={handleCloseHotListDrawer}
//             hotListName={hotListName}
//             selectedCandidate={selectedCandidate} // Pass the selected candidate from useState
//             hotListId={hotListId}
//           />
//         )}
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default CandidateListDrawer;
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import CreateHotListDraw from "./CreateHotListDraw";
import { useDispatch, useSelector } from "react-redux";
import { allLocation } from "../../redux/common/locationSlice";
import { getCandidateList } from "../../redux/hotlist/hotListSlice";

const CandidateListDrawer = ({
  show,
  handleClose,
  hotListName,
  hotListId,
  //   candidateList,
}) => {
  const dispatch = useDispatch();
  const [showHotListDrawer, setShowHotListDrawer] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null); // Local state for selected candidate
  const [isFetchingMore, setIsFetchingMore] = useState(false); // Track fetching more candidates
  
  const candidateList = useSelector((state) => state.hotlist.candidates) || [];
  const locations = useSelector((state) => state.location) || [];
  const candidateData = useSelector((store) => store?.candidate?.data || {});
  console.log("candidateList", candidateList);
  const {
    profiles = [],
    next_page = null,
    total_resume_profiles = 0,
    total_pages = 0,
    current_page = 1,
    success = false,
  } = candidateData;

  console.log(
    profiles,
    "profiles",
    success,
    locations,
    selectedCandidate,
    selectedCandidate
  );

  // Ref for the last candidate element to observe for infinite scroll
  const observerRef = useRef(null);
  const lastCandidateRef = useCallback(
    (node) => {
      if (isFetchingMore) return; // Skip if already fetching
      if (observerRef.current) observerRef.current.disconnect(); // Disconnect previous observer

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && next_page !== null) {
          // Fetch next page when the last element is visible
          setIsFetchingMore(true);
          dispatch(getAllCandidate({ page: current_page + 1 })).then(() => {
            setIsFetchingMore(false);
          });
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isFetchingMore, next_page, current_page, dispatch]
  );

  useEffect(() => {
    // Fetch the first page of candidates when the component mounts
    dispatch(getAllCandidate({ page: 1 }));
    dispatch(allLocation());
  }, [dispatch]);

  // Cleanup observer on unmount
  useEffect(() => {
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, []);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name || "Unknown Location";
  };

  // Function to check if a candidate is already in candidateList
  const isCandidateInList = (candidate) => {
    return candidateList?.some(
      (listedCandidate) =>
        listedCandidate.mobile_no === candidate.mobile_no &&
        listedCandidate.full_name === candidate.full_name &&
        listedCandidate.email === candidate.email
    );
  };

  const handleCloseHotListDrawer = useCallback(() => {
    setShowHotListDrawer(false);
    setSelectedCandidate(null); // Clear the selected candidate when closing the drawer
  }, []);

  const handleAddToHotlist = (candidate) => {
    // Store the selected candidate in local state
    setSelectedCandidate(candidate);
    // Open the hotlist drawer
    setShowHotListDrawer(true);
  };

    useEffect(() => {
      if (hotListId) {
        dispatch(getCandidateList(hotListId));
      }
    }, [dispatch, hotListId]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px 10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
            }}
          >
            <Typography>Candidate Listing | {hotListName}</Typography>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>

          {/* Candidate List or Circular Progress */}
          <Box sx={{ marginTop: "10px", padding: "0px 10px" }}>
            {!success ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                <CircularProgress />
              </Box>
            ) : profiles.length === 0 ? (
              <Typography sx={{ textAlign: "center", padding: "20px" }}>
                No candidates found.
              </Typography>
            ) : (
              <>
                {profiles?.map((candidate, index) => {
                  const isAdded = isCandidateInList(candidate); // Check if candidate is in candidateList
                  // Attach ref to the last candidate in the list for infinite scroll
                  const isLastCandidate = index === profiles.length - 1;
                  return (
                    <Box
                      key={index}
                      ref={isLastCandidate ? lastCandidateRef : null} // Attach observer to the last candidate
                      sx={{
                        padding: "10px",
                        border: "1px solid #e0e0e0",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        borderRadius: "3px",
                        marginBottom: "10px",
                      }}
                    >
                      <Box>
                        <Typography>{candidate.full_name}</Typography>
                        <Typography style={{ margin: "5px 0" }}>
                          {candidate.current_job_title},{" "}
                          {candidate.total_experience} Years
                        </Typography>
                        <Typography>
                          {getLocationById(candidate?.current_location)}
                        </Typography>
                        <Typography>${candidate.rate} Hourly</Typography>
                      </Box>
                      <button
                        style={{
                          padding: "5px 10px",
                          backgroundColor: isAdded ? "#d3d3d3" : "#f0f0f0",
                          border: "none",
                          borderRadius: "2px",
                          cursor: isAdded ? "not-allowed" : "pointer",
                        }}
                        onClick={() =>
                          !isAdded && handleAddToHotlist(candidate)
                        }
                        disabled={isAdded}
                      >
                        {isAdded ? "Added" : "Add to Hotlist"}
                      </button>
                    </Box>
                  );
                })}
                {/* Show loading spinner while fetching more candidates */}
                {isFetchingMore && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <CircularProgress size={24} />
                  </Box>
                )}
                {/* Optional: Show a message when there are no more candidates */}
                {next_page === null && profiles.length > 0 && (
                  <Typography sx={{ textAlign: "center", padding: "10px" }}>
                    No more candidates to load.
                  </Typography>
                )}
              </>
            )}
          </Box>
        </Box>
        {showHotListDrawer && (
          <CreateHotListDraw
            show={showHotListDrawer}
            handleClose={handleCloseHotListDrawer}
            hotListName={hotListName}
            selectedCandidate={selectedCandidate}
            hotListId={hotListId}
          />
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CandidateListDrawer;
